<template>
    <div class="dt-wrapper">
        <div v-if="scopes.length > 0" class="dt-scope-wrap">
            <button class="dt-scope-nav-btn" type="button" @click="scrollPills(-160)">
                <i class="fas fa-chevron-left fa-xs"></i>
            </button>
            <div ref="pillsRef" class="dt-scope-filter">
                <span class="dt-scope-label">View:</span>
                <div class="dt-scope-pills" role="group">
                    <input id="scope" v-model="scope" name="scope" type="radio" class="btn-check" autocomplete="off" value="all" />
                    <label class="dt-pill" for="scope">All</label>

                    <template v-for="(item, i) in scopes" :key="i">
                        <input :id="`scope-${i}`" v-model="scope" name="scope" type="radio" class="btn-check" autocomplete="off" :value="scopeValue(item)" />
                        <label class="dt-pill" :for="`scope-${i}`">{{ scopeLabel(item) }}</label>
                    </template>
                </div>
            </div>
            <button class="dt-scope-nav-btn" type="button" @click="scrollPills(160)">
                <i class="fas fa-chevron-right fa-xs"></i>
            </button>
        </div>
        <table ref="view" class="table w-100">
            <thead v-if="showHeader">
                <slot name="header" />
            </thead>
            <tbody>
                <slot name="body" />
            </tbody>
            <tfoot v-if="showFooter">
                <slot name="footer" />
            </tfoot>
        </table>
    </div>
</template>
<script lang="ts">
// @ts-nocheck
import { AxiosError } from 'axios'
import * as Bootstrap from 'bootstrap'
import $ from 'jquery'
import 'jquery-migrate'
//import 'jszip'
//import 'pdfmake'

import DataTable, { Api } from 'datatables.net-bs5'

import 'datatables.net-buttons-bs5'
//import 'datatables.net-buttons/js/buttons.colVis.mjs'
//import 'datatables.net-buttons/js/buttons.html5.mjs'
//import 'datatables.net-buttons/js/buttons.print.mjs'
import 'datatables.net-fixedcolumns-bs5'
import 'datatables.net-fixedheader-bs5'
import 'datatables.net-responsive-bs5'
//import "datatables.net-scroller-bs5"
import 'datatables.net-searchbuilder-bs5'
import 'datatables.net-searchpanes-bs5'
import 'datatables.net-select-bs5'

// import "datatables.net-autofill-bs5"
// import "datatables.net-colreorder-bs5"
//import 'datatables.net-datetime'
// import "datatables.net-keytable-bs5"
import 'datatables.net-rowgroup-bs5'
// import "datatables.net-rowreorder-bs5"

import { merge } from 'lodash'
import Swal from 'sweetalert2'
import { Component, Prop, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'

@Component({})
class Datatable extends Vue {
    // eslint-disable-next-line no-undef
    datatable!: Api<HTMLTableElement>
    editor!: any //typeof Editor.Api<HTMLTableElement>

    scope = 'all'

    @Watch('scope')
    onScopeChange(value) {
        this.datatable.draw()
    }

    @Ref('view')
    readonly view!: HTMLTableElement

    @Prop({ type: Object, default: () => { } })
    readonly options!: Config

    @Prop({ type: Object, default: () => { } })
    readonly editorOptions!: object

    @Prop({ type: Array, default: () => [] })
    readonly scopes!: (string | { value: string; label: string })[]

    scopeValue(item: string | { value: string; label: string }): string {
        return typeof item === 'string' ? item : item.value
    }

    scopeLabel(item: string | { value: string; label: string }): string {
        return typeof item === 'string' ? item : item.label
    }

    scrollPills(delta: number) {
        const el = this.$refs.pillsRef as HTMLElement | undefined
        if (el) el.scrollBy({ left: delta, behavior: 'smooth' })
    }

    get showHeader() {
        return !!this.$slots.header
    }

    get showFooter() {
        return !!this.$slots.footer
    }

    deleteRow(data: object, force = false) {
        //this.datatable.processing(true)
        this.$http
            .delete(`${this.datatable.ajax.url()}/editor`, { params: { id: data.id, force } })
            .then(() => this.datatable.draw())
            .catch((e: AxiosError) => console.error(e.response.data.message))
        //.finally(() => this.datatable.processing(false))
    }

    destroyed() {
        //this.datatable.
    }

    created() {
        //this.options.data.scope = this.scope
    }

    mounted() {
        DataTable.use(Bootstrap)
        // @ts-ignore
        this.datatable = new DataTable(this.view, this.options)
        $(() => {
            $('.dt-search input').removeClass('form-control-sm').addClass('dt-search-input')
            $('.dt-length select').removeClass('form-select-sm').addClass('dt-length-select')
            $('.dataTable').addClass('table')

            $('.dt-search button').on('click', (e) => {
                e.preventDefault()

                const search = $('.dt-search input').val() as string

                if (search.length > 0) {
                    this.datatable.search(search).draw()
                }
            })

            $('.dt-search input').on('keydown', (e) => {
                if (e.key === 'Enter') {
                    const search = $('.dt-search input').val() as string

                    if (search.length > 0) {
                        this.datatable.search(search).draw()(e.currentTarget as HTMLInputElement).value = ''
                    }
                }
            })
        })

        document.onkeyup = (e) => {
            if (e.code === 'Delete') {
                const rows = this.datatable.rows({ selected: true })
                for (let i = 0; i < rows.count(); i++) {
                    this.deleteRow(rows.data()[i])
                }
            }
        }

        window.onresize = () => this.datatable.responsive.recalc()

        this.datatable.on('preXhr.dt', (e, settings, data) => (data.scope = this.scope))

        this.datatable.on('click', '.inertia-link', (e) => {
            e.preventDefault()
            this.router.visit((e.currentTarget as HTMLAnchorElement).href)
        })

        this.datatable.on('click', '.delete, .restore', ({ target }: { target: HTMLAnchorElement }) => {
            this.$sweet
                .fire({
                    title: 'Are You Sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'YES',
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const row = this.datatable.row($(target).parents('tr'))
                        const data = row.data()
                        this.deleteRow(data)
                    }
                })
        })

        this.datatable.on('click', '.clear', ({ target }: { target: HTMLAnchorElement }) => {
            const row = this.datatable.row($(target).parents('tr'))
            const data = row.data()
            this.$sweet
                .fire({
                    title: 'Are You Sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'YES',
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.deleteRow(data, true)
                        Swal.fire('Cleared!', 'Your record has been cleared from the database.', 'success')
                    }
                })
        })

        this.datatable.on('click', '.action', ({ target }: { target: HTMLAnchorElement }) => {
            const data = this.datatable.row($(target).parents('tr')).data()
            const path = $(target).data('path')
            this.$http.post(this.route(path, {}))
        })
        DataTable.ext.errMode = 'throw'
    }
}

export default toNative(Datatable)

$.fn.dataTable.Api.register('processing()', function (show) {
    return this.iterator('table', function (ctx) {
        ctx.oApi._fnProcessingDisplay(ctx, show)
    })
})

$.extend($.fn.dataTable.defaults, {
    search: {
        return: true,
    },
    //scrollY: 800,
    deferRender: true,
    scroller: true,
    searching: true,
    ordering: true,
    destroy: true,
    processing: true,
    responsive: true,
    serverSide: true,
    stateSave: true,
    stateSaveParams: (settings, data) => {
        data.search.search = ''
    },
    stateDuration: 60 * 60 * 24,
    autoWidth: true,
    //fixedHeader: true,
    lengthMenu: [10, 20, 50, 100],
    language: {
        info: '<span class="dt-info-text">_START_–_END_ of <b>_TOTAL_</b></span>',
        infoEmpty: '<span class="dt-info-text">0 records</span>',
        infoFiltered: '<span class="dt-info-text dt-info-filtered">(filtered from _MAX_)</span>',
        lengthMenu: '_MENU_',
        processing: '<div class="dt-loading-overlay"><div class="dt-loading-card"><div class="dt-loading-spinner-ring"></div><span class="dt-loading-label">Loading data…</span></div></div>',
        search: '_INPUT_',
        searchPlaceholder: 'Search…',
        loadingRecords: ' ',
        zeroRecords: '<div class="dt-empty-state"><i class="fas fa-inbox fa-2x mb-2 text-muted"></i><p class="text-muted mb-0">No matching records found</p></div>',
        emptyTable: '<div class="dt-empty-state"><i class="fas fa-inbox fa-2x mb-2 text-muted"></i><p class="text-muted mb-0">No data available</p></div>',
        paginate: {
            next: "<i class='fas fa-chevron-right'></i>",
            previous: "<i class='fas fa-chevron-left'></i>",
            first: "<i class='fas fa-angles-left'></i>",
            last: "<i class='fas fa-angles-right'></i>",
        },
        searchBuilder: {
            button: '<i class="fas fa-sliders-h me-1"></i>Filter',
        },
        searchPanes: {
            collapse: '<i class="fas fa-filter me-1"></i>Panes',
        },
    },
    // dom: "<'row table-head gy-1' <'col-md-4 col-12 d-flex justify-content-md-start justify-content-center' B>" +
    //     "<'col-md-8 col-12 d-flex justify-content-md-end justify-content-center' f l>>" +
    //     "<'row table-body my-1' <'col-12' <'table-indicator' r> t>>" +
    //     "<'row table-foot gy-' <'col-md-6 col-12 d-flex justify-content-md-start justify-content-center' i>" +
    //     "<'col-md-6 col-12 d-flex justify-content-md-end justify-content-center' p>>",
    layout: {
        //top1: 'searchBuilder',
        topStart: 'buttons',
        topEnd: ['search', 'pageLength'],
        bottomStart: 'info',
        bottomEnd: 'paging',
    },
    rowId: 'id',
    select: {
        style: 'os',
        selector: 'td:not(:last-child)',
        blurable: true,
    },
    ajax: {
        data: (data, settings) => {
            let api = new DataTable.Api(settings)
            data.columns.push({
                data: 'slug',
            })
            return merge(data, {
                trash: false,
                orderable: api.order().length > 0,
                scope: 'all',
            })
        },
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            XDEBUG_SESSION: 'vsc',
        },
    },
    columnDefs: [
        {
            targets: '_all',
            orderable: false,
            searchable: false,
            class: 'align-middle',
            width: '20px',
            defaultContent: '<i>N/A</i>',
            //type: 'num',
            // searchBuilder: {
            //     defaultCondition: '='
            // },
            //searchBuilderType: 'num'
        },
    ],
})

$.extend(true, DataTable.Buttons.defaults, {
    dom: {
        container: {
            tag: 'div',
            className: 'dt-buttons',
        },
    },
})

$.fn.dataTable.ext.buttons.refresh = {
    text: '<i class="fas fa-rotate-right"></i>',
    className: 'dt-btn-icon',
    titleAttr: 'Refresh',
    action: (_e, table) => table.ajax.reload(),
}

$.fn.dataTable.ext.buttons.create = {
    text: '<i class="fa fa-plus"></i>',
    className: 'dt-btn-icon dt-btn-primary',
    tag: 'a',
    titleAttr: 'Create',
    action: '',
    init: (_dt, node) => {
        node.off('click')
    },
}

$.fn.dataTable.ext.buttons.export = {
    text: '<i class="fas fa-cloud-download-alt"></i>',
    extend: 'collection',
    autoClose: true,
    titleAttr: 'Export Table Information',
    buttons: ['copy', 'excel', 'csv', 'pdf', 'print'],
}

$.fn.dataTable.ext.buttons.select = {
    extend: 'collection',
    text: '<i class="fas fa-check-square"></i>',
    className: 'btn-warning',
    autoClose: true,
    titleAttr: 'Select Table Information',
    buttons: [
        {
            extend: 'selectAll',
            text: 'Select All',
            titleAttr: 'Select All',
        },
        {
            extend: 'selectNone',
            text: 'Select None',
            titleAttr: 'Select None',
        },
    ],
}
$.fn.dataTable.ext.buttons.delete = {
    text: '<i class="fas fa-trash"></i>',
    extend: 'remove',
    titleAttr: 'Delete Selected Rows Data',
}

$.fn.dataTable.ext.buttons.filter = {
    text: '<i class="fas fa-filter"></i>',
    extend: 'collection',
    autoClose: true,
    value: null,
    buttons: [],
    init: (dt, node, config) => {
        dt.on('preXhr', (_e, _settings, data) => (data.filter = { type: config?.filter }))
        dt.on('xhr', (_e, _settings, { categories }) => {
            let buttons = []
            buttons = categories.map((item) => ({ text: item.title, action: () => dt.on('preXhr', (_e, _settings, data) => (data.filter.value = item.id)).draw() }))
            buttons.unshift('<hr />')
            buttons.unshift({ text: 'All', action: () => dt.on('preXhr', (_e, _settings, data) => (data.filter.value = null)).draw() })
            dt.button(null, node).collectionRebuild(buttons)
        })
    },
}

$.fn.dataTable.ext.buttons.trashed = {
    text: '<i class="fas fa-trash-can"></i>',
    titleAttr: 'Thrashed',
    action: (_e, dt, node) => {
        let { trash } = dt.ajax.params()
        if (trash) {
            dt.on('preXhr', (_e, _settings, data) => (data.trash = false)).draw()
            dt.button(0, node).text('<i class="fas fa-trash"></i>')
        } else {
            dt.on('preXhr', (_e, _settings, data) => (data.trash = true)).draw()
            dt.button(0, node).text('<i class="fas fa-trash-restore"></i>')
        }
    },
}

/* $.extend(true, $.fn.dataTable.Editor.defaults, {
        ajax: {
            remove: {
                method: 'DELETE',
                error: (xhr) => console.error(xhr.response),
                success: (response) => console.log(response),
            },
            edit: {
                method: 'PUT',
                error: (xhr) => console.error(xhr.response),
                success: (response) => console.log(response),
            },
        },
        table: '#table',
        idSrc: 'id',
    }) */

$(() => {
    //$('.btn-toolbar .btn').button('toggle')
    $('.filter input, .trash input').on('change', (e) => {
        let table = $(e.target).parents('.btn-toolbar').first().data('table')
        $(table).DataTable().ajax.reload()
    })
})

//})
</script>

<style lang="scss">
@import 'datatables.net-bs5/css/dataTables.bootstrap5.css';
//@import 'datatables.net-autofill-bs5/css/autoFill.bootstrap5.css';
@import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.css';
//@import 'datatables.net-colreorder-bs5/css/colReorder.bootstrap5.css';
@import 'datatables.net-datetime/css/dataTables.dateTime';
@import 'datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.css';
@import 'datatables.net-fixedheader-bs5/css/fixedHeader.bootstrap5.css';
//@import 'datatables.net-keytable-bs5/css/keyTable.bootstrap5.css';
@import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.css';
@import 'datatables.net-rowgroup-bs5/css/rowGroup.bootstrap5.css';
//@import 'datatables.net-rowreorder-bs5/css/rowReorder.bootstrap5.css';
@import 'datatables.net-scroller-bs5/css/scroller.bootstrap5.css';
@import 'datatables.net-searchbuilder-bs5/css/searchBuilder.bootstrap5.css';
@import 'datatables.net-searchpanes-bs5/css/searchPanes.bootstrap5.css';
@import 'datatables.net-select-bs5/css/select.bootstrap5.css';
@import 'datatables.net-staterestore-bs5/css/stateRestore.bootstrap5.css';

// ─── Scope filter bar ─────────────────────────────────────────────────────────
.dt-scope-wrap {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    margin-bottom: 0.75rem;
}

.dt-scope-nav-btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1.5px solid #e5e7eb;
    background: #fff;
    color: #6b7280;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;

    &:hover {
        background: #f3f4f6;
        border-color: #9ca3af;
        color: #374151;
    }
}

.dt-scope-filter {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    flex: 1;
    min-width: 0;
    background: #f9fafb;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar { display: none; }
}

.dt-scope-label {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: #9ca3af;
    white-space: nowrap;
    flex-shrink: 0;
    padding-right: 0.25rem;
    border-right: 1.5px solid #e5e7eb;
}

.dt-scope-pills {
    display: flex;
    flex-wrap: nowrap;
    gap: 0.375rem;
    align-items: center;
}

.dt-pill {
    display: inline-flex;
    align-items: center;
    padding: 0.3rem 0.9rem;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 500;
    cursor: pointer;
    border: 1.5px solid #e5e7eb;
    background: #fff;
    color: #6b7280;
    transition: background 0.15s, border-color 0.15s, color 0.15s, box-shadow 0.15s;
    user-select: none;
    white-space: nowrap;

    &:hover {
        border-color: #86efac;
        background: #f0fdf4;
        color: #15803d;
    }
}

.btn-check:checked + .dt-pill {
    background: linear-gradient(135deg, #1e3a2f, #3a7d52);
    border-color: transparent;
    color: #fff;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(30, 58, 47, 0.28);
}

// ─── Table layout ─────────────────────────────────────────────────────────────
.dt-wrapper {
    width: 100%;
}

.dataTable {
    width: 100% !important;
    border-collapse: separate;
    border-spacing: 0;

    thead tr th {
        background: #f8f9fa;
        border-bottom: 2px solid #e9ecef;
        border-top: none;
        padding: 0.75rem 1rem;
        vertical-align: middle;
        font-size: 0.875rem;
    }

    tbody tr {
        transition: background 0.1s;

        &:hover > td {
            background: #f0f6ff !important;
        }

        &.selected > td {
            background: #f0fdf4 !important;
        }

        td {
            padding: 0.65rem 1rem;
            vertical-align: middle;
            border-bottom: 1px solid #f1f3f5;
            border-top: none;
            font-size: 0.875rem;
        }
    }

    .avatar {
        max-width: 40px !important;
        border-radius: 50%;
    }
}

.dt-column-title {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #6c757d;
}

// ─── Top / bottom control bar ─────────────────────────────────────────────────
.dt-layout-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;

    &:first-child {
        padding-bottom: 0.75rem;
        border-bottom: 1px solid #f1f3f5;
        margin-bottom: 0;
    }

    &:last-child {
        padding-top: 0.75rem;
        border-top: 1px solid #f1f3f5;
        margin-top: 0;
    }
}

.dt-layout-start,
.dt-layout-end,
.dt-layout-full {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

// ─── Toolbar Buttons ──────────────────────────────────────────────────────────
// Must override datatables.net-buttons-bs5 defaults, hence !important
.dt-buttons {
    display: flex !important;
    gap: 0.375rem !important;
    flex-wrap: wrap;

    .dt-button,
    .dt-button.btn,
    .dt-button.btn-secondary,
    .dt-button.btn-primary,
    .dt-button.btn-default,
    button.dt-button {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 32px !important;
        min-width: 32px !important;
        padding: 0 0.6rem !important;
        border-radius: 7px !important;
        font-size: 0.82rem !important;
        font-weight: 500 !important;
        border: 1.5px solid #dee2e6 !important;
        background: #ffffff !important;
        color: #495057 !important;
        cursor: pointer !important;
        transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, color 0.15s !important;
        line-height: 1 !important;
        box-shadow: none !important;
        text-shadow: none !important;

        &:hover, &:focus {
            background: #f0f4ff !important;
            border-color: #90b4ff !important;
            color: #0d6efd !important;
            box-shadow: 0 1px 5px rgba(13,110,253,0.12) !important;
        }

        &:active {
            background: #e0eaff !important;
            transform: scale(0.96) !important;
        }

        &.dt-btn-primary {
            background: #0d6efd !important;
            border-color: #0d6efd !important;
            color: #fff !important;

            &:hover {
                background: #0a58ca !important;
                border-color: #0a58ca !important;
                color: #fff !important;
            }
        }

        i { pointer-events: none; }
    }
}

// ─── Search input ─────────────────────────────────────────────────────────────
.dt-search {
    display: inline-flex;
    align-items: center;
    position: relative;

    .dt-search-input,
    input[type="search"] {
        padding: 0.35rem 0.875rem 0.35rem 2.25rem;
        border: 1.5px solid #dee2e6;
        border-radius: 8px;
        font-size: 0.85rem;
        background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%236c757d' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cpath d='m21 21-4.35-4.35'/%3E%3C/svg%3E") no-repeat 0.65rem center;
        background-size: 14px;
        color: #212529;
        transition: border-color 0.15s, box-shadow 0.15s;
        width: 220px;

        &:focus {
            outline: none;
            border-color: #86b7fe;
            box-shadow: 0 0 0 3px rgba(13,110,253,.15);
        }

        &::placeholder { color: #adb5bd; }
    }
}

// ─── Length menu ──────────────────────────────────────────────────────────────
.dt-length {
    display: inline-flex;
    align-items: center;

    .dt-length-select,
    select {
        padding: 0.35rem 2rem 0.35rem 0.75rem;
        border: 1.5px solid #dee2e6;
        border-radius: 8px;
        font-size: 0.85rem;
        background-color: #fff;
        color: #212529;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236c757d' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 0.6rem center;
        background-size: 12px;
        margin-right: 0 !important;
        cursor: pointer;
        transition: border-color 0.15s, box-shadow 0.15s;

        &:focus {
            outline: none;
            border-color: #86b7fe;
            box-shadow: 0 0 0 3px rgba(13,110,253,.15);
        }
    }
}

// ─── Info text ────────────────────────────────────────────────────────────────
.dt-info {
    padding-top: 0 !important;
    font-size: 0.8rem;
    color: #6c757d;
}

.dt-info-text {
    font-size: 0.8rem;
    color: #6c757d;
}

.dt-info-filtered {
    margin-left: 0.25rem;
    color: #adb5bd;
}

// ─── Pagination ───────────────────────────────────────────────────────────────
.dt-paging {
    .pagination {
        gap: 0.25rem;
        margin-bottom: 0;

        .page-item {
            .page-link {
                border-radius: 6px !important;
                border: 1.5px solid #dee2e6;
                color: #495057;
                padding: 0.3rem 0.65rem;
                font-size: 0.82rem;
                line-height: 1.4;
                transition: background 0.15s, border-color 0.15s;

                &:hover {
                    background: #f8f9fa;
                    border-color: #adb5bd;
                }

                &:focus { box-shadow: 0 0 0 3px rgba(13,110,253,.15); }
            }

            &.active .page-link {
                background: #0d6efd;
                border-color: #0d6efd;
                color: #fff;
                box-shadow: 0 2px 6px rgba(13,110,253,.3);
            }

            &.disabled .page-link {
                color: #ced4da;
                background: transparent;
                border-color: #f1f3f5;
            }
        }
    }
}

// ─── Processing overlay ───────────────────────────────────────────────────────
.dt-processing {
    // Let DataTables control show/hide — do NOT override display here
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 20 !important;

    // Hide everything DataTables injects (dots, default wrappers, etc.)
    > * {
        display: none !important;
    }

    // Show only our custom card
    .dt-loading-overlay {
        display: flex !important;
    }
}

.dt-loading-overlay {
    display: none;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.dt-loading-card {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 0.75rem 1.4rem;
    box-shadow: 0 4px 20px rgba(30, 58, 47, 0.12);
}

@keyframes dt-spin {
    to { transform: rotate(360deg); }
}

.dt-loading-spinner-ring {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2.5px solid #d1fae5;
    border-top-color: #16a34a;
    animation: dt-spin 0.7s linear infinite;
    flex-shrink: 0;
}

.dt-loading-label {
    font-size: 0.82rem;
    font-weight: 600;
    color: #374151;
    white-space: nowrap;
}


// ─── Empty state ──────────────────────────────────────────────────────────────
.dt-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem 1rem;
}

// ─── Row action buttons ───────────────────────────────────────────────────────
.btn-group.btn-group-sm {
    gap: 0.25rem;

    .btn {
        border-radius: 6px !important;
        transition: opacity 0.15s, transform 0.1s, box-shadow 0.15s;

        &:hover { box-shadow: 0 2px 6px rgba(0,0,0,0.15); }
        &:active { transform: scale(0.94); }

        i { pointer-events: none; }
    }
}

// ─── Select highlight ─────────────────────────────────────────────────────────
table.dataTable tbody > tr.selected > * {
    box-shadow: inset 0 0 0 9999px rgba(22, 163, 74, 0.08) !important;
    color: #212529 !important;
}

table.dataTable tbody > tr.selected {
    border-left: 3px solid #16a34a;
}
</style>
